module.exports = __webpack_public_path__ + "img/pro_eight_2.0caa7555.jpg";